import { Link } from "react-router-dom";
import type { ContentType } from "@/mocks/media";
import { mediaList } from "@/mocks/media";

const entries: {
  type: ContentType;
  label: string;
  sub: string;
  icon: string;
  count: number;
  highlights: string;
}[] = [
  { type: "movie", label: "电影", sub: "院线佳片与经典修复", icon: "ri-film-line", count: 0, highlights: "悬疑 · 科幻 · 国风动画" },
  { type: "tv", label: "电视剧", sub: "刑侦、都市与东方古装", icon: "ri-tv-2-line", count: 0, highlights: "更新追更 · 全集速览" },
  { type: "variety", label: "综艺", sub: "访谈、真人秀与美食竞技", icon: "ri-mic-line", count: 0, highlights: "慢综艺 · 深度对谈" },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-6">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:gap-4">
        {entries.map((entry, index) => {
          const count = mediaList.filter((item) => item.type === entry.type).length;
          const isAccent = index === 1;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className={`group relative flex flex-col justify-between overflow-hidden rounded-lg border p-5 transition-all duration-300 md:p-6 ${
                isAccent
                  ? "border-primary-700 bg-primary-500 text-background-50 hover:bg-primary-600"
                  : "border-background-200 bg-background-100/70 text-foreground-950 hover:border-accent-300 hover:bg-background-50"
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md ${
                    isAccent ? "bg-background-50/15 text-background-50" : "bg-background-50 text-accent-600"
                  }`}
                >
                  <i className={`${entry.icon} text-xl`} />
                </span>
                <span
                  className={`font-label text-[11px] ${
                    isAccent ? "text-background-50/60" : "text-foreground-500"
                  }`}
                >
                  {count} 部在库
                </span>
              </div>
              <div className="mt-8">
                <h3 className={`font-heading text-lg font-bold ${isAccent ? "text-background-50" : ""}`}>
                  {entry.label}
                </h3>
                <p
                  className={`mt-1 text-[13px] ${
                    isAccent ? "text-background-50/70" : "text-foreground-600"
                  }`}
                >
                  {entry.sub}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span
                    className={`font-label text-[11px] ${
                      isAccent ? "text-background-50/55" : "text-foreground-500"
                    }`}
                  >
                    {entry.highlights}
                  </span>
                  <span
                    className={`flex h-7 w-7 items-center justify-center rounded-full transition-transform duration-300 group-hover:translate-x-1 ${
                      isAccent ? "bg-background-50/15 text-background-50" : "bg-accent-100 text-accent-700"
                    }`}
                  >
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}